// extracted by mini-css-extract-plugin
export default {"hiddenCaptcha":"styles_hiddenCaptcha__UtLCc","isOpen":"styles_isOpen__-8KQy","modal":"styles_modal__Fkm4U","closeIcon":"styles_closeIcon__rb9ZD","isHidden":"styles_isHidden__A+Rnq"};